import AppContext from "PFApp/app_context";
import AutoSelect from "PFComponents/select/autoselect";
import EchartsWrapper from "PFCore/helpers/echarts_wrapper";
import useInsightsApi from "PFCore/helpers/use_insights_api";
import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import BarPreview from "../../previews/bar_preview";
import { rolesHistChartConfig } from "./configs/roles_hist_chart_config";
import css from "./roles_hist_chart.module.scss";

const RolesHistChart = () => {
  const {
    store: {
      pages: {
        insights: { selectedFilters, setModalData }
      }
    }
  } = useContext(AppContext);

  const { t } = useTranslation("insights");
  const [timeToStage, setTimeToStage] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [stage, setStage] = useState({ value: "shortlisted_at", text: t("shortlistCreated") });
  const { insightsApi, insightsApiError } = useInsightsApi();

  useEffect(() => {
    setLoading(true);
    insightsApi("/roles_hist", {
      stage: stage.value,
      ...selectedFilters
    }).then((res) => {
      setTimeToStage(res.time_to_stage);
      setLoading(false);
    });
  }, [selectedFilters, stage]);

  if (insightsApiError) {
    return <BarPreview content={t("noData")} />;
  }

  const displayContent = Boolean(timeToStage);

  if (!displayContent) {
    return <BarPreview animated content={t("loading")} />;
  }

  return (
    <>
      <div className={css.wrapper}>
        <div className={css.chart}>
          <div>
            <AutoSelect
              multi={false}
              closeOnChange={true}
              values={[stage]}
              letClear={false}
              query={() =>
                Promise.resolve(timeToStage.stages.map((item) => ({ text: item.label, value: item.value })))
              }
              handleChange={(selected) => {
                setStage(selected[0]);
              }}
              disabled={loading}
              allowSameValueInOptions
            />
          </div>
          {timeToStage && timeToStage.bar.length > 0 && !insightsApiError ? (
            <EchartsWrapper
              height={500}
              onClick={(e) => {
                setModalData({
                  stage: stage.value,
                  time_to_stage: timeToStage.bar[e.dataIndex].time,
                  title: t("rolesList"),
                  parent: "hist",
                  chartType: "roles_hist"
                });
              }}
              options={rolesHistChartConfig(
                t("saveImage"),
                timeToStage.bar.map((data) => t("countHours", { count: data.time })),
                timeToStage.bar.map((data) => data.count)
              )}
            />
          ) : (
            <BarPreview content={t("noData")} />
          )}
        </div>
      </div>
    </>
  );
};

RolesHistChart.propTypes = {
  filters: PropTypes.object
};

export default RolesHistChart;
